export enum FormCodeEditorLanguageEnum {
  Json = 'json',
  JavaScript = 'javascript',
  TypeScript = 'typescript',
  Html = 'html',
  Css = 'css',
  Scss = 'scss',
  Xml = 'xml',
  Sql = 'sql',
  Yaml = 'yaml',
  Markdown = 'markdown',
  PlainText = 'plaintext',
}
